import verticals from './modules/verticals';

export default {
  namespaced: true,
  modules: {
    verticals,
  },
};
